import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {choose} from 'lit/directives/choose.js';

import store from '../../store';
import {conditional} from '../../util/conditional';
import {selectSpcConfiguration} from '../../selectors';


@customElement('shared-tender-text-page')
export class SharedTenderTextPage extends connect(store)(LitElement) {

	static styles = css`
		.pageContainer {
			display: flex;
			justify-content: space-between;
			width: 100%;
			gap: 1cqw;
			padding-top: 2cqw;
		}
		.image {
			container-type: inline-size;
			width: 30%;
			max-height: 297mm;
		}
		.sketch {
			width: 100%;
			display: block;
			padding: 0 15cqw 0 10cqw;
			box-sizing: border-box;
		}
		.tenderText {
			width: 70%;
		}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.productData = state.productData;
		this.status = state.status;
		this.lang = state.status.lang;
		this.lightProfile = state.lightProfile.data;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}

	c(id) {
		return conditional(this.spcConfiguration, this.conditionalVariantValues, id);
	}

	render() {
		const s = this.state;
		return html`
			<div class="pageContainer">
				<div class="image">
					${choose(
						this.status.family, [
							[
								'LightProfile',
								() => html`
									<light-profile-image></light-profile-image>`
							],
							[
								'TheLine',
								() => html`
									<line-drawing></line-drawing>`
							], [
								'Aeto',
								() => html`
									<svg-aeto-drawing></svg-aeto-drawing>`
							]
						],
						() => html`
							${when( this.c('REDTAB.RETURN_LU_Sketch') && this.c('REDTAB.RETURN_LU_Sketch') !=='', () => html`
								<img class="sketch" alt="sketch" src="${this.c('REDTAB.RETURN_LU_Sketch')}" />
							`)}
						`)
					}
				</div>

				<div class="tenderText">
					${choose(
						this.status.family, [
							[
								'LightProfile',
								() => html`
									<new-light-tender-text></new-light-tender-text>`
							],
							[
								'TheLine',
								() => html`
									<line-tender-text></line-tender-text>`
							], [
								'Aeto',
								() => html`
									<solar-tender-text></solar-tender-text>`
							]
						],
						() => html`
							<general-tender-text></general-tender-text>
						`)
					}
				</div>
			</div>
		`;
	}
}
